import React from 'react';
import { RECENT_EVENTS } from '../data/images';

// ── EVENT TAG COLORS ──────────────────────────────────────────
// Add new tag colors here if you add new event types
const TAG_COLORS = {
  Conference: { bg: '#E8F0F8', color: '#1A4A7A' },
  Meeting:    { bg: '#F5E8EB', color: '#861F41' },
  Outreach:   { bg: '#E8F5EC', color: '#2D7A4F' },
  Social:     { bg: '#FFF3E8', color: '#E5751F' },
  Workshop:   { bg: '#F3E8FF', color: '#7C3AED' },
  Default:    { bg: '#F0F0F0', color: '#555' },
};

export default function RecentEvents() {
  return (
    <section id="events" style={{ padding: '80px 24px', background: 'white' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 48, flexWrap: 'wrap', gap: 16 }}>
          <div>
            <span className="section-label">Recent Events</span>
            <h2 className="section-title">What We've Been Up To</h2>
          </div>
          <a href="#calendar" className="btn btn-outline" style={{ fontSize: 14 }}>
            View Full Calendar →
          </a>
        </div>

        {/* Event Cards — data comes from src/data/images.js RECENT_EVENTS array */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 28 }}>
          {RECENT_EVENTS.map((event, i) => {
            const tagStyle = TAG_COLORS[event.tag] || TAG_COLORS.Default;
            return (
              <div key={i} className="card" style={{ cursor: 'pointer' }}>
                {/* Event photo — UPDATE photo in RECENT_EVENTS in images.js */}
                <div style={{
                  height: 200, overflow: 'hidden', position: 'relative',
                  background: '#1A1A1A',
                }}>
                  <img
                    src={event.photo}
                    alt={event.title}
                    style={{
                      width: '100%', height: '100%', objectFit: 'cover',
                      transition: 'transform 0.4s ease',
                    }}
                    onMouseEnter={e => e.target.style.transform = 'scale(1.05)'}
                    onMouseLeave={e => e.target.style.transform = 'scale(1)'}
                    onError={e => { e.target.style.display = 'none'; }}
                  />
                  <div style={{
                    position: 'absolute', top: 12, left: 12,
                    background: 'rgba(0,0,0,0.65)', borderRadius: 100,
                    padding: '4px 12px', fontSize: 12, color: 'white', fontWeight: 600,
                  }}>
                    {event.date}
                  </div>
                  {/* Tag badge */}
                  <div style={{
                    position: 'absolute', top: 12, right: 12,
                    background: tagStyle.bg, color: tagStyle.color,
                    borderRadius: 100, padding: '4px 12px',
                    fontSize: 11, fontWeight: 700, letterSpacing: 0.5,
                  }}>
                    {event.tag}
                  </div>
                </div>

                <div style={{ padding: '24px 24px 28px' }}>
                  <h3 style={{
                    fontFamily: 'Playfair Display, serif',
                    fontSize: 18, fontWeight: 700, marginBottom: 10, color: '#1A1A1A',
                  }}>
                    {event.title}
                  </h3>
                  <p style={{ fontSize: 14, color: '#666', lineHeight: 1.7 }}>
                    {event.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div style={{ textAlign: 'center', marginTop: 48 }}>
          <p style={{ color: '#888', marginBottom: 16, fontSize: 15 }}>
            Don't miss our upcoming events — check the calendar below!
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="#calendar" className="btn btn-primary">View Full Calendar</a>
            <a href="https://www.instagram.com/shpe_vt/" target="_blank" rel="noopener noreferrer" className="btn btn-outline">
              Follow @shpe_vt
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
